import { Box, Button, Tooltip } from '@shared/components';

interface QSetDisablementButtonProps {
  disabled: boolean;
  onClick: () => void;
}

export default function QSetDisablementButton(props: Readonly<QSetDisablementButtonProps>) {
  const { disabled, onClick } = props;

  return (
    <Tooltip
      title={
        disabled ? (
          <>
            ไม่สามารถ Disabled ชุดข้อสอบที่ถูก Assign
            <br />
            หรือกำลังถูกใช้งานในการสอบได้
          </>
        ) : (
          ''
        )
      }
    >
      <Box>
        <Button disabled={disabled} size='small' color='error' variant='outlined' onClick={onClick}>
          Disable
        </Button>
      </Box>
    </Tooltip>
  );
}
